export default "__VITE_ASSET__BwEYqvyI__"